export const FLAG_GETTING_DELIVERY_POSTAL_CODE_PRICES =
  'FLAG_GETTING_DELIVERY_POSTAL_CODE_PRICES';
export const GET_DELIVERY_POSTAL_CODE_PRICES =
  'GET_DELIVERY_POSTAL_CODE_PRICES';
export const CLEAR_DELIVERY_POSTAL_CODE_PRICES =
  'CLEAR_DELIVERY_POSTAL_CODE_PRICES';
export const FLAG_DELIVERY_POSTAL_CODE_PRICE_ACTIVITY =
  'FLAG_DELIVERY_POSTAL_CODE_PRICE_ACTIVITY';
export const GET_DELIVERY_POSTAL_CODE_PRICE = 'GET_DELIVERY_POSTAL_CODE_PRICE';
export const CLEAR_DELIVERY_POSTAL_CODE_PRICE =
  'CLEAR_DELIVERY_POSTAL_CODE_PRICE';
